"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const AccessType_enum_1 = require("../ts/enums/AccessType.enum");
const BucketListingAction_enum_1 = require("../ts/enums/BucketListingAction.enum");
const getPar_1 = __importDefault(require("../apiBucket/getPar"));
const uploadFile = (filePath, file, isBeCall) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const getParBody = {
            objectName: filePath,
            accessType: AccessType_enum_1.AccessType.OBJECT_READ_WRITE,
            bucketListingAction: BucketListingAction_enum_1.BucketListingAction.LIST_OBJECTS,
        };
        // Recupero il par autorizzato per fare l'upload del file
        // nel path filePath
        const parResponse = yield (0, getPar_1.default)(getParBody, isBeCall);
        const parData = parResponse.data;
        const { accessUri } = parData;
        yield axios_1.default.put(accessUri, file);
        return 'OK';
    }
    catch (error) {
        console.log(error);
        return null;
    }
});
exports.default = uploadFile;
